[
    {
        "time": "20160609",
        "title": "线下活动开启，宣布社区成立",
        "type": "编程讨论",
        "address": "拾级Cafe",
        "describe": "线下活动开启，宣布社区成立",
        "imageList": [
            {
                "url": "./xxx",
                "describe": "xxxxxxxxxxxx"
            }
        ]
    },
    {
        "time": "20160703",
        "title": "携手编程-成都社区主页初版",
        "type": "动手编程",
        "address": "拾级Cafe",
        "describe": "携手编程-成都社区主页初版",
        "imageList": [
            {
                "url": "./xxx",
                "describe": "xxxxxxxxxxxx"
            }
        ]
    },
    {
        "time": "20160911",
        "title": "结对编程的理念",
        "type": "个人分享+结对编程",
        "address": "拾级Cafe",
        "describe": "结对编程的理念",
        "imageList": [
            {
                "url": "./xxx",
                "describe": "xxxxxxxxxxxx"
            }
        ]
    },
    {
        "time": "20161106",
        "title": "console的九大命令+学习路线分享",
        "type": "个人分享",
        "address": "拾级Cafe",
        "describe": "console的九大命令+学习路线分享",
        "imageList": [
            {
                "url": "./xxx",
                "describe": "xxxxxxxxxxxx"
            }
        ]
    },
    {
        "time": "20161119",
        "title": "git的使用与个人简历制作",
        "type": "分享+编程",
        "address": "拾级Cafe",
        "describe": "git的使用与个人简历制作",
        "imageList": [
            {
                "url": "./xxx",
                "describe": "xxxxxxxxxxxx"
            }
        ]
    },
    {
        "time": "20161204",
        "title": "Chrome开发者工具全解",
        "type": "个人分享",
        "address": "拾级Cafe",
        "describe": "Chrome开发者工具全解",
        "imageList": [
            {
                "url": "./xxx",
                "describe": "xxxxxxxxxxxx"
            }
        ]
    },
    {
        "time": "20161217",
        "title": "结对编程-保龄球积分+FizzBuzz?",
        "type": "结对编程",
        "address": "拾级Cafe",
        "describe": "结对编程-保龄球积分+FizzBuzz?",
        "imageList": [
            {
                "url": "./xxx",
                "describe": "xxxxxxxxxxxx"
            }
        ]
    },
    {
        "time": "20161231",
        "title": "一个平凡程序员的自述 + CSS布局那些事",
        "type": "个人分享",
        "address": "拾级Cafe",
        "describe": "一个平凡程序员的自述 + CSS布局那些事",
        "imageList": [
            {
                "url": "./xxx",
                "describe": "xxxxxxxxxxxx"
            }
        ]
    },
    {
        "time": "20170115",
        "title": "JSpace_Plane小游戏",
        "type": "分享 + 编程",
        "address": "拾级Cafe",
        "describe": "JSpace_Plane小游戏",
        "imageList": [
            {
                "url": "./xxx",
                "describe": "xxxxxxxxxxxx"
            }
        ]
    },
    {
        "time": "20170212",
        "title": "BootStrap + xMemory家用云服务器",
        "type": "个人分享",
        "address": "拾级Cafe",
        "describe": "BootStrap + xMemory家用云服务器",
        "imageList": [
            {
                "url": "./xxx",
                "describe": "xxxxxxxxxxxx"
            }
        ]
    },
    {
        "time": "20170305",
        "title": "半程黑客松 - 春季",
        "type": "编程黑客松",
        "address": "拾级Cafe",
        "describe": "半程黑客松 - 春季",
        "imageList": [
            {
                "url": "./xxx",
                "describe": "xxxxxxxxxxxx"
            }
        ]
    },
    {
        "time": "20170318",
        "title": "Bitmap & Sort + 技术文档导读",
        "type": "个人分享",
        "address": "拾级Cafe",
        "describe": "Bitmap & Sort + 技术文档导读",
        "imageList": [
            {
                "url": "./xxx",
                "describe": "xxxxxxxxxxxx"
            }
        ]
    },
    {
        "time": "20170402",
        "title": "React + 虚拟DOM",
        "type": "个人分享",
        "address": "拾级Cafe",
        "describe": "React + 虚拟DOM",
        "imageList": [
            {
                "url": "./xxx",
                "describe": "xxxxxxxxxxxx"
            }
        ]
    },
    {
        "time": "20170415",
        "title": "HTTP与RESTful API + GraphQL",
        "type": "个人分享与讨论",
        "address": "拾级Cafe",
        "describe": "HTTP与RESTful API + GraphQL",
        "imageList": [
            {
                "url": "./xxx",
                "describe": "xxxxxxxxxxxx"
            }
        ]
    },
    {
        "time": "20170429",
        "title": "编程的思想，解决现实生活中的问题",
        "type": "分享与引导",
        "address": "拾级Cafe",
        "describe": "编程的思想，解决现实生活中的问题",
        "imageList": [
            {
                "url": "./xxx",
                "describe": "xxxxxxxxxxxx"
            }
        ]
    },
    {
        "time": "20170506",
        "title": "开发者关系大会-成都分会场",
        "type": "直播观影 + 现场分享",
        "address": "拾级Cafe",
        "describe": "开发者关系大会-成都分会场",
        "imageList": [
            {
                "url": "./xxx",
                "describe": "xxxxxxxxxxxx"
            }
        ]
    },
    {
        "time": "20170521",
        "title": "Python+ Django 快速搭建 Blog",
        "type": "编程指导",
        "address": "拾级Cafe",
        "describe": "Python+ Django 快速搭建 Blog",
        "imageList": [
            {
                "url": "./xxx",
                "describe": "xxxxxxxxxxxx"
            }
        ]
    },
    {
        "time": "20170603",
        "title": "Game of Life. React?",
        "type": "个人分享 + 结对编程",
        "address": "拾级Cafe",
        "describe": "Game of Life. React?",
        "imageList": [
            {
                "url": "./xxx",
                "describe": "xxxxxxxxxxxx"
            }
        ]
    },
    {
        "time": "20170618",
        "title": "半程黑客松 - 夏季",
        "type": "编程黑客松",
        "address": "拾级Cafe",
        "describe": "半程黑客松 - 夏季",
        "imageList": [
            {
                "url": "./xxx",
                "describe": "xxxxxxxxxxxx"
            }
        ]
    },
    {
        "time": "20170624",
        "title": "Webassembly",
        "type": "微信群问答式交流",
        "address": "拾级Cafe",
        "describe": "Webassembly",
        "imageList": [
            {
                "url": "./xxx",
                "describe": "xxxxxxxxxxxx"
            }
        ]
    },
    {
        "time": "20170702",
        "title": "程序员如何提高职业竞争力 + 程序员创业 & 项目管理",
        "type": "个人分享",
        "address": "拾级Cafe",
        "describe": "程序员如何提高职业竞争力 + 程序员创业 & 项目管理",
        "imageList": [
            {
                "url": "./xxx",
                "describe": "xxxxxxxxxxxx"
            }
        ]
    },
    {
        "time": "20170715",
        "title": "DevOps从理论到实践 + 敏捷四把刀",
        "type": "个人分享",
        "address": "拾级Cafe",
        "describe": "DevOps从理论到实践 + 敏捷四把刀",
        "imageList": [
            {
                "url": "./xxx",
                "describe": "xxxxxxxxxxxx"
            }
        ]
    },
    {
        "time": "20170730",
        "title": "社区主页改造",
        "type": "结对编程",
        "address": "拾级Cafe",
        "describe": "社区主页改造",
        "imageList": [
            {
                "url": "./xxx",
                "describe": "xxxxxxxxxxxx"
            }
        ]
    },
    {
        "time": "20170806",
        "title": "编程静修日",
        "type": "自习，交流",
        "address": "拾级Cafe",
        "describe": "编程静修日",
        "imageList": [
            {
                "url": "./xxx",
                "describe": "xxxxxxxxxxxx"
            }
        ]
    },
    {
        "time": "20170812",
        "title": "浅谈如何提高工作效率 + 现场答疑",
        "type": "个人分享 + 现场答疑",
        "address": "拾级Cafe",
        "describe": "浅谈如何提高工作效率 + 现场答疑",
        "imageList": [
            {
                "url": "./xxx",
                "describe": "xxxxxxxxxxxx"
            }
        ]
    },
    {
        "time": "20170827",
        "title": "H5 在线编辑器工具开发详解",
        "type": "个人分享",
        "address": "拾级Cafe",
        "describe": "H5 在线编辑器工具开发详解",
        "imageList": [
            {
                "url": "./xxx",
                "describe": "xxxxxxxxxxxx"
            }
        ]
    },
    {
        "time": "20170910",
        "title": "TypeScript在项目中的应用",
        "type": "个人分享",
        "address": "拾级Cafe",
        "describe": "TypeScript在项目中的应用",
        "imageList": [
            {
                "url": "./xxx",
                "describe": "xxxxxxxxxxxx"
            }
        ]
    },
    {
        "time": "20170924",
        "title": "有趣的Three.js + 逐步在Docker中构建CI流程",
        "type": "个人分享",
        "address": "拾级Cafe",
        "describe": "有趣的Three.js + 逐步在Docker中构建CI流程",
        "imageList": [
            {
                "url": "./xxx",
                "describe": "xxxxxxxxxxxx"
            }
        ]
    },
    {
        "time": "20171021",
        "title": "Jetbrains插件开发入门 + 一小时入门Web应用开发",
        "type": "个人分享",
        "address": "拾级Cafe",
        "describe": "Jetbrains插件开发入门 + 一小时入门Web应用开发",
        "imageList": [
            {
                "url": "./xxx",
                "describe": "xxxxxxxxxxxx"
            }
        ]
    },
    {
        "time": "20171105",
        "title": "用算法解决实际问题 + 前端实用算法串烧",
        "type": "个人分享",
        "address": "拾级Cafe",
        "describe": "用算法解决实际问题 + 前端实用算法串烧",
        "imageList": [
            {
                "url": "./xxx",
                "describe": "xxxxxxxxxxxx"
            }
        ]
    },
    {
        "time": "20171119",
        "title": "2017成都Web前端大会",
        "type": "大型交流活动",
        "address": "拾级Cafe",
        "describe": "2017成都Web前端大会",
        "imageList": [
            {
                "url": "./xxx",
                "describe": "xxxxxxxxxxxx"
            }
        ]
    },
    {
        "time": "20171210",
        "title": "编程道场",
        "type": "个人分享 + 结对编程",
        "address": "拾级Cafe",
        "describe": "编程道场",
        "imageList": [
            {
                "url": "./xxx",
                "describe": "xxxxxxxxxxxx"
            }
        ]
    },
    {
        "time": "20180120",
        "title": "【Code for City】黑客松",
        "type": "编程比赛 + 路演 + 主题分享",
        "address": "拾级Cafe",
        "describe": "【Code for City】黑客松",
        "imageList": [
            {
                "url": "./xxx",
                "describe": "xxxxxxxxxxxx"
            }
        ]
    }
]